import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { deleteFile, getData, getFile, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible, setVisibleSecondary } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import saveAs from "file-saver";


interface ActividadState {
    status: string;
    error: string;
    actividadSesionList: any[],
    actividadSesion: {
        idTareaSesion: number | null;
        idGrupoSesion: number | null;
        nombre: string | null;
        descripcion: string | null;
        urlArchivo: string | null;
        fechaInicio: Date | null;
        fechaVencimiento: Date | null;
        nombreArchivo: string | null;
        fileData: string | null;
        fileUrl: string | null;
    }

}

const initialState: ActividadState = {
    status: 'idle',
    error: '',
    actividadSesionList: [],
    actividadSesion: {
        idTareaSesion: null,
        idGrupoSesion: null,
        nombre: null,
        descripcion: null,
        urlArchivo: null,
        fechaInicio: null,
        fechaVencimiento: null,
        nombreArchivo: null,
        fileData: null,
        fileUrl: null
    }
}

export const fetchActividadSesion = createAsyncThunk('fetchActividadSesion', async ({ idGrupoSesion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 127;
    const { result, message, data } = await getData({ idsp, idGrupoSesion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const createModifyActividad = createAsyncThunk('createModifyActividad', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const actividadNew = selectActividadSesion(state);
    const actividadSesionAttributes = { ...actividadNew };
    const idsp = actividadSesionAttributes.idTareaSesion ? 128 : 126;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...actividadSesionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (actividadSesionAttributes.fileData !== null && actividadSesionAttributes.fileData !== '') {
            const { result: resultFile } = await postFile({ idsp: 129, id: data, dir: "actividad", fileData: actividadSesionAttributes.fileData, fileName: data }, getState, dispatch);
            if (!resultFile) {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "ARCHIVO NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchActividadSesion({ idGrupoSesion: actividadSesionAttributes.idGrupoSesion }));
    return rejectWithValue(message);
});

export const downloadActividad = createAsyncThunk('downloadActividad', async (_: any, { dispatch, getState }) => {
    const state: any = getState();
    const actividadNew = selectActividadSesion(state);
    const actividadSesionAttributes = { ...actividadNew };
    let alert: AlertInterface;
    if (actividadSesionAttributes.fileUrl) {
        const fileExtension = actividadSesionAttributes.fileUrl.substring(actividadSesionAttributes.fileUrl.lastIndexOf('.'));
        const fileName = `${actividadSesionAttributes.nombreArchivo}${fileExtension}`;
        const response = await getFile({ fileUrl: actividadSesionAttributes.fileUrl, fileName: fileName });

        if (response && response.blob) {
            saveAs(response.blob, fileName);
            alert = { title: 'CORRECTO..!', message: "ARCHIVO DESCARGADO CORRECTAMENTE", data: [], type: 'LimeGreen', time: Date.now() };
        } else {
            alert = { title: 'ACCIÓN INCOMPLETA', message: "ARCHIVO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
        }
    } else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: "ARCHIVO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
});

export const deleteActividadSesion = createAsyncThunk('deleteActividadSesion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const actividadNew = selectActividadSesion(state);
    const actividadSesionAttributes = { ...actividadNew };
    const idsp = 130;
    let alert: AlertInterface;
    const { result, message, data } = await getData({ idsp, idTareaSesion: actividadSesionAttributes.idTareaSesion }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (actividadSesionAttributes.fileUrl !== null && actividadSesionAttributes.fileUrl !== '') {
            await deleteFile([{ fileUrl: actividadSesionAttributes.fileUrl }], getState, dispatch);
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchActividadSesion({ idGrupoSesion: actividadSesionAttributes.idGrupoSesion }));
    return rejectWithValue(message);
});

export const actividadSesionSlice = createSlice({
    name: 'actividadSesion',
    initialState,
    reducers: {
        setactividadSesionList: (state, action) => {
            state.actividadSesionList = action.payload;
        },
        setActividadSesion: (state, action) => {
            state.actividadSesion = !action.payload ? initialState.actividadSesion : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchActividadSesion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchActividadSesion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.actividadSesionList = data ? data : [];

            })
            .addCase(fetchActividadSesion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectactividadSesionList = (state: RootState) => state.actividadSesion.actividadSesionList;
export const selectActividadSesion = (state: RootState) => state.actividadSesion.actividadSesion;

export const { setactividadSesionList, setActividadSesion } = actividadSesionSlice.actions;

export default actividadSesionSlice.reducer;